<template>
  <div class="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
    <div class="relative bg-white shadow-lg w-full md:w-[500px] h-[640px] rounded-lg">
      <button
       @click="$emit('close')"
        class="absolute top-0 right-0 -mt-4 -mr-4 p-2 bg-gray-200 rounded-full hover:bg-gray-300 focus:outline-none"
      >
        <svg
          class="w-6 h-6 text-gray-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </button>

      <!-- Iframe -->
      <iframe
        v-if="widgetId && !loading && iframeUrl"
        :src="iframeUrl"
        width="100%"
        height="100%"
        frameborder="0"
        class="rounded-lg"
      ></iframe>
      
      <div v-else-if="loading" class="flex flex-col items-center justify-center h-full p-8 space-y-4">
        <div class="relative w-16 h-16">
          <div class="absolute inset-0 rounded-full border-4 border-gray-300 border-t-blue-500 animate-spin"></div>
          <div class="absolute inset-2 rounded-full border-4 border-gray-200 border-b-blue-400 animate-spin animation-delay-150"></div>
        </div>
        <div class="text-center space-y-2">
          <h3 class="text-lg font-medium text-gray-700 animate-pulse">Loading Enrollment Widget</h3>
          <p class="text-sm text-gray-500">Please wait while we connect you...</p>
          <div class="w-full bg-gray-200 rounded-full h-1.5 mt-4">
            <div class="bg-blue-500 h-1.5 rounded-full animate-progress"></div>
          </div>
        </div>
      </div>

      <div v-else class="flex flex-col items-center justify-center h-full p-8 text-center">
        <div class="bg-gray-100 p-6 rounded-lg w-full max-w-md">
          <h3 class="text-xl font-semibold text-gray-700 mb-4">For Enquiry</h3>
          <p class="text-gray-600 mb-6">Please contact us directly for assistance</p>
          
          <div class="bg-gray-200 p-4 rounded-lg">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 mx-auto text-gray-500 mb-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <p class="text-2xl font-medium text-gray-800"> +919240013644</p>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "EnquireNow",
  props:["widget_id"],
  data() {
    return {
      widgetId: null,
      loading: false,
      defaultWidgetId: "4F82AB36-66AE-4046-B1DE-1DFDF017E977"
    };
  },
  computed: {
    iframeUrl() {
      if (!this.widgetId) return null;
      return `https://widget.prod.umsglobal.net/#/?color=white&leadOwner=jain_landing_page&leadSource=jain_landing_page&leadOrigin=jain_landing_page&academia_id=7A1FA08E-A78C-453E-8D0B-F394598A5922&university=jain&widget_id=${this.widgetId}`;
    }
  },
  async created() {
    this.loading = true;
    if (this.widget_id != null && this.widget_id != '') {
      this.widgetId = this.widget_id
      this.loading = false;

    } else {
      this.widgetId = this.defaultWidgetId
      this.loading = false;

    }
    // try {
    //   if (this.$route.name === "elective-detail") {
    //     console.log(this.$route)
    //     const { short_slug, elective_slug } = this.$route.params;
    //     await this.fetchWidget(short_slug, elective_slug);
    //     this.loading = false;
    //   } else {
    //     this.widgetId = this.defaultWidgetId;
    //     this.loading = false;
    //   }
    // } catch (error) {
    //   console.error("Error loading widget:", error);
    //   this.widgetId = null;
    //   this.loading = false;
    // }
  },
  methods: {
    async fetchWidget(programSlug, electiveSlug) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/ums/partner/widget/${programSlug}/${electiveSlug}/`
        );
        this.widgetId = response.data.widget_id || this.defaultWidgetId;
        // this.widgetId = null;
        
      } catch (error) {
        console.error("Failed to fetch widget:", error);
        this.widgetId = null; 
      }
    }
  }
};
</script>

<style scoped>
.animate-spin {
  animation: spin 1.5s linear infinite;
}
.animation-delay-150 {
  animation-delay: 0.15s;
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.animate-progress {
  animation: progress 2.5s ease-in-out infinite;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}
@keyframes progress {
  0% { width: 0%; }
  50% { width: 100%; }
}
</style>